/* PattePlanet : collection (tri automatique). Fonctionne aussi sans JS via les formulaires GET. */
(function () {
  'use strict';
  function boot() {
    var sel = document.querySelector('[data-sort-select]');
    if (sel && sel.form) sel.addEventListener('change', function () { sel.form.submit(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
